<div class="jsrs-show-when-expanded" id="myMail">
  <ng-container *ngIf="loading">
    <mprd-mymail-skeleton-mailboxes></mprd-mymail-skeleton-mailboxes>
  </ng-container>

  <ng-container *ngIf="!loading">
    <mprd-mailboxes-container></mprd-mailboxes-container>
  </ng-container>
</div>
